import React, { useContext } from "react";
import { Button, Space } from "antd";
import {
  LeftOutlined,
  RightOutlined,
  MenuOutlined,
  SettingOutlined,
  UserAddOutlined,
  LogoutOutlined,
} from "@ant-design/icons";

import "./MobileToolBar.less";
import useQueryParams from "../../hooks/useQueryParams";
import { useHistory } from "react-router";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import LogoutButton from "../button/LogoutButton";
import { AuthContext } from "../../contexts/auth/AuthContext";

export default function MobileToolBar({
  onMenuButtonClicked,
}: {
  onMenuButtonClicked: () => void;
}) {
  const query = useQueryParams();
  const history = useHistory();
  const {authState} = useContext(AuthContext)
  const { md } = useBreakpoint();

  return (
    <Space className="mobile-toolbar" size={15}>
      <Button
        size={md ? "small" : "middle"}
        onClick={() => history.goBack()}
        icon={<LeftOutlined />}
      />
      <Button
        size={md ? "small" : "middle"}
        onClick={() => history.goForward()}
        icon={<RightOutlined />}
      />
      <Button
        size={md ? "small" : "middle"}
        onClick={() => query.set("settings", "open")}
        icon={<SettingOutlined />}
      />
      {(authState.user?.userName === "Administrator" || authState.user?.userName === "Moderator") && <Button
        size={md ? "small" : "middle"}
        onClick={() => query.set("add-admin", "true")}
        icon={<UserAddOutlined />}
      />}
      <LogoutButton
        placement="top"
        button={
          <Button size={md ? "small" : "middle"} icon={<LogoutOutlined />} />
        }
      />
      <Button
        size={md ? "small" : "middle"}
        onClick={() => onMenuButtonClicked()}
        icon={<MenuOutlined />}
      />
    </Space>
  );
}
